import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { AdvanceInitTitle, DataTables } from "../../../Constant";
import StockResult from "./StockResult";
import RowCreateCallback from "./RowCreateCallback";

const AdvanceInitContainer = () => {
  return (
    <>
      <Breadcrumbs pageTitle={AdvanceInitTitle} parent={DataTables} title={AdvanceInitTitle} />
      <Container fluid>
        <Row>
          <StockResult />
          <RowCreateCallback/>
        </Row>
      </Container>
    </>
  );
};

export default AdvanceInitContainer;
